import ForgotPasswordFormView from './ForgotPasswordFormView';

export default ForgotPasswordFormView;